module.exports = __webpack_public_path__ + "static/img/147_TO8_1857.ed346df.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/147_TO8_1857.jpg
// module id = sBh6
// module chunks = 0